import { FC, useEffect } from 'react';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import SurveyDefaultStep from '@/components/SurveyDefaultStep';
import BagsImage from '@/assets/images/bags.png';
import analytics from '@/utils/analytics/analyticsInstance';

const ShoppersStoriesPage: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: '5000+ shoppers like you share their stories',
    });
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: '5000+ shoppers like you share their stories' }}
      subTitle={{
        value:
          'Product reviews, tips & favorites. Join the community to discover the best products ',
      }}
      image={BagsImage}
      button={{ onClick: next }}
    />
  );
};

export default ShoppersStoriesPage;
